import React from 'react';
import classes from './controller.module.css';

const Controller = (props) => {
    return (
        <div className={classes.BuildControl}>
            <button className={classes.Less} disabled={props.disable} onClick={props.rmHandler}>
                <span className="material-icons" style={{verticalAlign:'middle'}}>clear</span>LESS</button>
            <p className={classes.Label}>{props.label}</p>
            <button className={classes.More} onClick={props.handler}>
                <span className="material-icons" style={{verticalAlign:'middle'}}>add</span>Add</button>
        </div>
    );
}

export default Controller;